<app-progress></app-progress>
<div class="mainDiv">
  <head>
    <title>{{ brand_Name }}</title>
  </head>
  <!-- TemplateData.NewDesign picks the header; neither until it is known -->
  <app-header *ngIf="isHeaderVisible && newDesign === false"></app-header>
  <app-new-header *ngIf="isHeaderVisible && newDesign === true"></app-new-header>
  <router-outlet></router-outlet>
</div>

<div *ngIf="whatsappno && isWhatsAppVisible" class="d-block d-md-none">
  <button
    type="button"
    class="float-btn float-btn--whatsapp"
    aria-label="Chat on WhatsApp"
    (click)="openMobileWhatsApp()"
  >
    <img src="../assets/img/whatsapp.png" alt="" width="58" height="58" decoding="async" />
  </button>
</div>

<div *ngIf="whatsappno && isWhatsAppVisible" class="d-none d-md-block">
  <button
    type="button"
    class="float-btn float-btn--whatsapp"
    aria-label="Chat on WhatsApp"
    (click)="openWhatsApp()"
  >
    <img src="../assets/img/whatsapp.png" alt="" width="58" height="58" decoding="async" />
  </button>
</div>

<app-allergens-footer *ngIf="isAllergenseFooterVisible"></app-allergens-footer>

<app-new-footer *ngIf="isFooterVisible"></app-new-footer>

<div class="bottomMenuContainer" *ngIf="bottomMenu && isBottomMenuVisible">
  <app-bottom-menu></app-bottom-menu>
</div>

<!-- Legacy extras popup: always mounted — the legacy recipe card, legacy
     dine-in and the products pages open it, and with NewDesign off so does
     ProductCardService. -->
<div>
  <app-popup></app-popup>
</div>

<!-- Loaded on demand, not part of main.js (lazy-components.ts): the AI chat
     only for brands that enable it, the options modal when an item is
     opened, the redesigned recommendations popup once the app is idle (or on
     the first checkout, whichever comes first). -->
<ng-container
  *ngIf="showRetailAIWidget"
  [appLazyComponent]="loadRetailAiWidget"
  [lazyInputs]="{ assistantName: assistantName }"
></ng-container>

<ng-container
  *ngIf="recipeOptionModalState"
  [appLazyComponent]="loadRecipeOptionModal"
  [lazyInputs]="{ state: recipeOptionModalState }"
  (lazyCreated)="onRecipeOptionModalCreated($event)"
></ng-container>

<ng-container
  *ngIf="mountRecomendations"
  [appLazyComponent]="loadNewRecomendations"
></ng-container>
<!-- legacy recommendations popup (RecomendationsSwitchService picks one) -->
<app-recomendations *ngIf="newDesign === false"></app-recomendations>
<app-select-delivery-type></app-select-delivery-type>
<app-inquiry-popup></app-inquiry-popup>

<app-welcome-message></app-welcome-message>

<app-connection-check></app-connection-check>

<app-cookie-banner></app-cookie-banner>
